module.exports = __webpack_public_path__ + "img/02a_marketing.57ef62fc.jpg";